import type { HttpClient } from './HttpClient';
import type { IObserverOffice } from './IObserverOffice';
import type { IObserverOffices } from './IObserverOffices';
import type { IPlatformUser } from './IPlatformUser';
import type { PlatformUserStatus } from './PlatformUserStatus';

/**
 * Адміністрування платформи (прототип v4 «Загальне», «Способи входу», «Розміщення полів», «Глобальні ролі»): налаштування платформи
 * (ключ → JSON-значення; змінює адміністратор платформи, об'єкти зливаються з поточним значенням), глобальні ролі облікових записів, а також
 * (рішення 5 етапу 7, лише адміністратор платформи) деактивація й відновлення облікових записів і скидання чи видалення демо-офісів спостерігача.
 */
export class PlatformDao {
  constructor(private readonly http: HttpClient) {}

  settings(): Promise<Record<string, unknown>> { return this.http.get('/platform/settings'); }
  setSetting(key: string, value: unknown): Promise<Record<string, unknown>> { return this.http.put(`/platform/settings/${encodeURIComponent(key)}`, value); }
  users(q?: string, status?: PlatformUserStatus): Promise<IPlatformUser[]> { return this.http.get('/platform/users', { q, status }); }
  setGlobalRole(userId: string, globalRole: string): Promise<IPlatformUser> { return this.http.put(`/platform/users/${userId}/global-role`, { globalRole }); }
  deactivateUser(userId: string): Promise<IPlatformUser> { return this.http.post(`/platform/users/${userId}/deactivate`); }
  reactivateUser(userId: string): Promise<IPlatformUser> { return this.http.post(`/platform/users/${userId}/reactivate`); }
  observerOffices(): Promise<IObserverOffices> { return this.http.get('/platform/observer-offices'); }
  resetObserverOffice(workspaceId: string): Promise<IObserverOffice> { return this.http.post(`/platform/observer-offices/${workspaceId}/reset`); }
  deleteObserverOffice(workspaceId: string): Promise<void> { return this.http.delete(`/platform/observer-offices/${workspaceId}`); }
}
